/**
 * How big a scope-picker row is, per presentation (BON-534).
 *
 * One table rather than conditionals scattered through three components, so the
 * sheet and the dropdown cannot end up disagreeing about a size. Values are the
 * design's own (`region-selector.jsx`): the sheet is thumb-sized — a 44px row
 * with a 44px caret beside it — and the menu is the denser pointer version.
 */
export type ScopeRowVariant = 'menu' | 'sheet';

export interface ScopeRowMetrics {
  /** Minimum tap/click height of a row. */
  rowHeight: number;
  /** Width reserved for the caret, and the indent a leaf uses instead. */
  caretWidth: number;
  /** Indent applied per level of depth. */
  indentStep: number;
  radius: number;
  /** Font size of a top-level name; children step down one. */
  label: number;
  childLabel: number;
  /** The right-hand caption (the director, or the region count). */
  meta: number;
  rowPadding: string;
  caretIcon: number;
}

export const SCOPE_ROW_METRICS: Record<ScopeRowVariant, ScopeRowMetrics> = {
  menu: {
    rowHeight: 0,
    caretWidth: 18,
    indentStep: 17.6,
    radius: 7,
    label: 13,
    childLabel: 12.5,
    meta: 10.5,
    rowPadding: '0.45rem 0.6rem',
    caretIcon: 12,
  },
  sheet: {
    rowHeight: 44,
    caretWidth: 44,
    indentStep: 20,
    radius: 10,
    label: 15,
    childLabel: 14,
    meta: 11.5,
    rowPadding: '8px 14px',
    caretIcon: 14,
  },
};
